const DRAFT_PLAN_STATUS = 'Rascunho';
const INACTIVE_PLAN_STATUS = 'Inativo';
const SCHEDULED_PLAN_STATUS = 'Agendado';
const SCHEDULING_PLAN_STATUS = 'Em Agendamento';
export { DRAFT_PLAN_STATUS, INACTIVE_PLAN_STATUS, SCHEDULED_PLAN_STATUS, SCHEDULING_PLAN_STATUS };
